import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getFullBlobUrl } from '@app/utils/blobUrl';

export interface EmployeeOptionLike {
  label: string;
  avatar_url?: string | null;
  employee_code?: string;
  department?: string;
}

/** Dòng option nhân viên (avatar + tên + mã • bộ phận) dùng chung cho mọi Select chọn nhân viên. */
const EmployeeOptionItem: React.FC<{ item: EmployeeOptionLike }> = ({ item }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <Avatar
      src={getFullBlobUrl(item.avatar_url ?? undefined) || undefined}
      icon={<UserOutlined />}
      size={32}
      className="tw-bg-primary tw-shrink-0"
    />
    <div style={{ flex: 1, minWidth: 0 }}>
      <div className="tw-text-[13px] tw-font-medium tw-text-on-surface">{item.label}</div>
      {item.employee_code && (
        <div className="tw-text-[11px] tw-text-on-surface-variant">
          {item.employee_code}
          {item.department && ` • ${item.department}`}
        </div>
      )}
    </div>
  </div>
);

export default EmployeeOptionItem;
